/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import Vue from 'vue';
import { get, sortBy } from 'lodash';

export const namespaced = true;

export const MPPT_TEMPLATE = (index) => ({
    id: index + 1,
    panel: null,
    series: 1,
    parallel: 1,
    dcus: 0
});

const getDefaultState = () => {
    return {
        // systems: [{"id":1583924991657,"mppts":[{"id":1,"panel":{"id":1,"uid":"26cecac2-c6f8-4d92-91a7-d3ef1ccfb3ee","dateCreated":"2020-03-06 04:27:34","dateUpdated":"2020-03-06 04:49:20","ownerId":"0039000002IlYBBAA3","type":"pvModule","model":"STM6-270/60","manufacturer":"Anhui Schutten Solar Energy Co Ltd","salesforceId":"a079000000pbSuTAAU","companyId":"0019000001xIV3IAAW","details":{"powerRating":"201","powerToleranceLower":"201","powerToleranceUpper":"201","moduleEfficiency":"0.8","voc":"201","panelIsc":"201","vmp":"201","imp":"201","vDeratingCelsius":"0.5","iDerating":"0.5","pDerating":"0.5","maxSystemVoltage":"200","seriesFuseRating":"200","panelDimensionsLength":"","panelDimensionsWidth":"","panelDimensionsHeight":"","weight":"","connectorManufacturer":"","connectorType":""},"expiry":"2021-04-26 10:00:00","expired":0,"valid":1},"series":54,"parallel":30,"dcus":0}],"inverter":{"id":10,"uid":"550520bb-5ceb-4f9c-8369-b7b98a2a9c65","dateCreated":"2020-03-10 14:14:44","dateUpdated":"2020-03-10 14:23:19","ownerId":"0039000002IlYBBAA3","type":"inverter","model":"ED05KFN1112","manufacturer":"LG Electronics Inc","salesforceId":"a0690000012cu88AAA","companyId":"0019000001xIV3IAAW","details":{"inverterType":"micro","maxDCWatts":"9","dcInputVoltageRangeLower":"9","dcInputVoltageRangeUpper":"9","minMPPVoltage":"9","maxInputVoltage":"9","numberOfMPPTrackers":"1","maxInputCurrent":["9"],"maxShortCircuitCurrent":["9"],"connectorManufacturer":"9","connectorType":"9","nominalOutputPower":"9","maxOutputPower":"9","acOutputCurrent":"9","numberOfPhases":"2","rcdType":"9","inverterDimensionsDepth":"9","inverterDimensionsWidth":"9","inverterDimensionsHeight":"9","inverterClearanceAbove":"9","inverterClearanceSides":"9","inverterClearanceBelow":"9","weight":"9","ipRating":"9","topology":"transformer","ambientTempMin":"9","ambientTempMax":"9","europeanEfficiency":"","efficiency":"0.05287"},"expiry":"2021-06-29 10:00:00","expired":0,"valid":1}},{"id":1583925030809,"mppts":[{"id":1,"panel":{"id":11,"uid":"1957d895-f6f8-4461-bdb8-3aa312ec8859","dateCreated":"2020-03-10 14:39:07","dateUpdated":"2020-03-10 14:41:49","ownerId":"0039000002IlYBBAA3","type":"pvModule","model":"HOGJ-M2-290-60C","manufacturer":"Tianjin HuanOu International Silicon Material Co Ltd","salesforceId":"a079000000qGcQXAA0","companyId":"0019000001xIV3IAAW","details":{"powerRating":"9","moduleEfficiency":"0.09","powerToleranceLower":"9","powerToleranceUpper":"9","voc":"9","panelIsc":"2.666","vmp":"9","imp":"9","vDeratingCelsius":"1","iDerating":"1","pDerating":"1","maxSystemVoltage":"9","seriesFuseRating":"9","panelDimensionsLength":"9","panelDimensionsWidth":"9","panelDimensionsHeight":"9","weight":"9","connectorManufacturer":"9","connectorType":"9"},"expiry":"2021-04-18 10:00:00","expired":0,"valid":1},"series":9,"parallel":4,"dcus":9},{"id":2,"panel":{"id":1,"uid":"26cecac2-c6f8-4d92-91a7-d3ef1ccfb3ee","dateCreated":"2020-03-06 04:27:34","dateUpdated":"2020-03-06 04:49:20","ownerId":"0039000002IlYBBAA3","type":"pvModule","model":"STM6-270/60","manufacturer":"Anhui Schutten Solar Energy Co Ltd","salesforceId":"a079000000pbSuTAAU","companyId":"0019000001xIV3IAAW","details":{"powerRating":"201","powerToleranceLower":"201","powerToleranceUpper":"201","moduleEfficiency":"0.8","voc":"201","panelIsc":"201","vmp":"201","imp":"201","vDeratingCelsius":"0.5","iDerating":"0.5","pDerating":"0.5","maxSystemVoltage":"200","seriesFuseRating":"200","panelDimensionsLength":"","panelDimensionsWidth":"","panelDimensionsHeight":"","weight":"","connectorManufacturer":"","connectorType":""},"expiry":"2021-04-26 10:00:00","expired":0,"valid":1},"series":9,"parallel":4,"dcus":36}],"inverter":{"id":8,"uid":"5b87b212-b5a0-47f9-82af-48a8b13da772","dateCreated":"2020-03-06 16:05:14","dateUpdated":"2020-03-06 16:05:58","ownerId":"0039000002IlYBBAA3","type":"inverter","model":"Hyper-3000","manufacturer":"The Trustee for Soltaro Unit Trust","salesforceId":"a069000001SrvCJAAZ","companyId":"0019000001xIV3IAAW","details":{"inverterType":"string","maxDCWatts":"5","dcInputVoltageRangeLower":"5","dcInputVoltageRangeUpper":"5","minMPPVoltage":"5","maxInputVoltage":"5","numberOfMPPTrackers":"2","maxInputCurrent":["5","5"],"maxShortCircuitCurrent":["5","5"],"connectorManufacturer":"5","connectorType":"5","nominalOutputPower":"5","maxOutputPower":"5","acOutputCurrent":"5","numberOfPhases":"2","rcdType":"5","inverterDimensionsDepth":"8","inverterDimensionsWidth":"8","inverterDimensionsHeight":"8","inverterClearanceAbove":"8","inverterClearanceSides":"8","inverterClearanceBelow":"8","weight":"8","ipRating":"8","topology":"transformer","ambientTempMin":"8","ambientTempMax":"8","europeanEfficiency":"0.08","efficiency":"0.08"},"expiry":"2021-12-07 11:00:00","expired":0,"valid":1},"dcu":true}],
        systems: [{ id: Date.now() }],
        singlePanelSet: false
    };
};

export const state = getDefaultState();

export const mutations = {
    ADD_SYSTEM(state) {
        state.systems.push({
            id: Date.now()
        });
    },

    UPDATE_SYSTEM(state, newData) {
        // Find system
        let system = state.systems.find((sys) => sys.id == newData.id);

        // Handle dcu setting change
        if (Object.prototype.hasOwnProperty.call(newData, 'dcu')) {
            system = { ...system, dcu: newData.dcu };
        }

        // Handle inverter change
        if (Object.prototype.hasOwnProperty.call(newData, 'inverter')) {
            // Get inverterType
            const oldInverter = {
                type: get(system, 'inverter.details.inverterType', 'OLD_INVALID'),
                maxMppts: Number(get(system, 'inverter.details.numberOfMPPTrackers', 0))
            };

            const newInverter = {
                type: get(newData, 'inverter.details.inverterType', 'NEW_INVALID'),
                maxMppts: Number(get(newData, 'inverter.details.numberOfMPPTrackers', 1))
            };

            let mpptDifference = newInverter.maxMppts - oldInverter.maxMppts;

            // If inverter is different type, delete mppts
            if (oldInverter.type != newInverter.type || !Object.prototype.hasOwnProperty.call(system, 'mppts')) {
                Vue.set(system, 'mppts', []);
                mpptDifference = newInverter.maxMppts;
            }

            const mpptDifferenceAbs = Math.abs(mpptDifference);
            const mpptDifferenceSign = Math.sign(mpptDifference);

            if (mpptDifferenceSign > 0) {
                // If new inverter has more MPPT capacity, add them
                Array(mpptDifferenceAbs).fill().map(() => {
                    system.mppts.push(MPPT_TEMPLATE(system.mppts.length));
                });
            } else if (mpptDifferenceSign < 0) {
                // If less, remove from the back
                Array(mpptDifferenceAbs).fill().map(() => {
                    system.mppts.pop();
                });
            } else if (system.mppts.length === 0) {
                // If new system or MPPTs have been reset, add in the correct amount
                Array(newInverter.maxMppts).fill().map(() => {
                    system.mppts.push(MPPT_TEMPLATE(system.mppts.length))
                });
            }

            system = { ...system, inverter: newData.inverter };
        }

        state.systems = [
            ...state.systems.filter((sys) => sys.id != newData.id),
            system
        ];
    },

    UPDATE_CONFIG(state, payload) {
        state.systems = payload;
    },

    REMOVE_SYSTEM(state, uid) {
        state.systems = state.systems.filter((sys) => sys.uid != uid);
    },

    SET_SINGLE_PANEL(state, panel) {
        state.singlePanelSet = true;

        state.systems.forEach((system) => {
            system.mppts.forEach((mppt) => {
                mppt.panel = panel;
            });
        });
    },

    PREVENT_SET_SINGLE_PANEL(state) {
        state.singlePanelSet = true;
    },

    RESET_STATE(state) {
        Object.assign(state, getDefaultState());
    }
};

export const actions = {
    addSystem({ commit }) {
        commit('ADD_SYSTEM');
    },

    updateSystem({ commit }, system) {
        commit('UPDATE_SYSTEM', system);
    },

    removeSystem({ commit }, uid) {
        commit('REMOVE_SYSTEM', uid);
    },

    updateConfiguration({ commit }, config) {
        commit('UPDATE_CONFIG', config);
    },

    resetState({ commit }) {
        commit('RESET_STATE');
    },

    // If only 1 panel is added to shortlist, populate all MPPTs with said panel.
    // Only do this once incase user removes panles from config and then wants to change
    // panel shortlist
    setSinglePanel({ commit, state, rootGetters }) {
        const panels = rootGetters['products/panelSimpleArray'];

        if (!state.singlePanelSet && panels.length === 1) {
            commit('SET_SINGLE_PANEL', panels[0]);
        }
    },

    // Remove any panels from config that arent in shortlist
    removeRougePanels({ state, rootState, dispatch }) {
        // Create simple array of shortlist
        const panels = rootState.products.shortlist.map((product) => {
            return product.panel.uid;
        });

        // Loop systems and remove panels if needed
        const cleanedConfig = state.systems.map((system) => {
            const cleanedMppts = system.mppts.map((mppt) => {
                const clonedMppt = { ...mppt };

                if (clonedMppt.panel && !panels.includes(clonedMppt.panel.uid)) {
                    clonedMppt.panel = null;
                }

                return clonedMppt;
            });

            return { ...system, mppts: cleanedMppts };
        });

        // Resave config via updateConfiguration
        dispatch('updateConfiguration', cleanedConfig);
    },

    populateConfiguration({ commit, rootState }, payload) {
        const updatedConfig = payload.configuration.map((system, systemIndex) => {
            let inverter = payload.products.inverters.inverters.find((inv) => inv.id == system.id);

            const mpptMax = Number(get(inverter, 'details.numberOfMPPTrackers', 1));
            const mppts = Array(mpptMax).fill().map((i, index) => {
                const foundMppt = system.mppts.find((mppt) => mppt.id == index + 1);
                return foundMppt ? {
                    ...foundMppt,
                    panel: payload.products.pvModules.panels.find((prod) => prod.id == foundMppt.panel.id),
                } : MPPT_TEMPLATE(index);
            });

            // Check to see if the system has a unique identifier
            // added 22/02/2021
            if (!system.uid) {
                system.uid = Date.now() + systemIndex;
            }

            return {
                ...system,
                inverter,
                mppts
            };
        });

        commit('PREVENT_SET_SINGLE_PANEL');

        commit('products/REMOVE_FROM_SHORTLIST', rootState.products.shortlist[0].id, { root:true });
        payload.products.pvModules.panels.forEach(panel => {
            commit('products/UPDATE_SHORTLIST', { id: panel.id, panel }, { root:true });
        })

        commit('UPDATE_CONFIG', updatedConfig);
    },
};

export const getters = {
    // Sort by ID
    sorted: (state) => sortBy(state.systems, ['id']),

    formatted: (state) => {
        return state.systems.map((system, index) => {
            // Panels
            const mppts = system.mppts.reduce((filtered, mppt) => {
                if (mppt.panel) {
                    filtered.push({
                        ...mppt,
                        panel: {
                            id: mppt.panel.id,
                            salesforceId: mppt.panel.salesforceId,
                        },
                    });
                }

                return filtered;
            }, []);

            // May need to add more data here
            return {
                uid: Date.now() + index,
                id: system.inverter.id,
                salesforceId: system.inverter.salesforceId,
                inverterType: system.inverter.details.inverterType,
                dcu: system.dcu,
                mppts,
            }
        });
    }
};
